module.exports = __webpack_public_path__ + "img/luthi-8.b60dbe85.jpg";